import type { LanguageDto } from "api/types";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

const defaultLanguage = "en";
// Storage shouldn't be subscribed to as it's not synced with the server
// Changing this would make two tabs trigger an infinite loop of updates
const nonSyncedStorage = createJSONStorage<LanguageDto["id"]>();
nonSyncedStorage.subscribe = undefined;
export const languageAtom = atomWithStorage<LanguageDto["id"]>("AoP.language", defaultLanguage, nonSyncedStorage);
